import React from 'react'
import { navigate } from '@reach/router'
import styled from 'styled-components'
import { peerjs } from 'peerjs/dist/peerjs.min'

import { ReactComponent as ChatIcon } from '../assets/icons/chat.svg'
import { ReactComponent as CallIcon } from '../assets/icons/call.svg'
import { ReactComponent as VideoIcon } from '../assets/icons/video.svg'

const { util } = peerjs

export default (props) => {
	const browsers = ['chrome', 'firefox', 'safari']
	const supported = browsers.includes(util.browser)

	const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1)

	return (
		<Container>
			<Section top>
				<Header>
					{supported ? (
						<Browser>
							You're running {capitalize(util.browser)}
							<span>{util.browserVersion && util.browserVersion}</span>
						</Browser>
					) : (
						<Browser>Not a supported browser</Browser>
					)}

					<Supported>
						<b>supported</b> features
					</Supported>

					<Features>
						<Feature supported={util.supports.data}>
							<ChatIcon />
						</Feature>

						<Feature supported={util.supports.audioVideo}>
							<CallIcon />
						</Feature>

						<Feature supported={util.supports.audioVideo}>
							<VideoIcon />
						</Feature>
					</Features>
				</Header>

				<Button top onClick={() => navigate('/new')}>
					New
				</Button>
			</Section>
			<Section>
				<Button onClick={() => navigate('/join')}>Join</Button>
			</Section>
		</Container>
	)
}

const Container = styled.section`
	height: 100%;
	display: flex;
	flex-direction: column;
`
const Section = styled.section<{ top? }>`
	flex: 1;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;

	justify-content: ${({ top }) => top && 'flex-end'};
	background: ${({ top, theme }) =>
		top ? theme.colors.white : theme.colors.primary};
`
const Header = styled.div`
	margin-top: 2rem;
	margin-bottom: 5rem;
`
const Browser = styled.p`
	font-size: 1.3rem;
	margin-bottom: 2rem;
	position: relative;
	color: ${({ theme }) => theme.colors.primary};

	> span {
		position: absolute;
		right: -1.4rem;
		top: 0.2rem;
		font-size: 0.7rem;
		line-height: 1.5;
		font-weight: bold;
		letter-spacing: 0.08rem;
		color: ${({ theme }) => theme.colors.accent};
	}
`
const Supported = styled.p`
	color: ${({ theme }) => theme.colors.primary};
`
const Features = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`
const Feature = styled.span<{ supported }>`
	margin: 1rem;

	> svg path {
		stroke: ${({ theme, supported }) => !supported && theme.colors.grey[0]};
	}
`
const Button = styled.button<{ top? }>`
	width: 150px;
	height: 50px;
	font-size: 0.9rem;
	border: none;
	outline: none;
	cursor: pointer;

	:focus {
		outline: none;
		text-decoration: underline;
	}

	background: ${({ top, theme }) =>
		top ? theme.colors.primary : theme.colors.white};
	color: ${({ top, theme }) =>
		top ? theme.colors.white : theme.colors.primary};
`
